import type { CreateTariffDto, TariffDto, TariffListDto, UpdateTariffDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { DataRequestDto, EntitySchemaDto, IdNameDto, PageRequestDto } from '../models';

@Injectable({
  providedIn: 'root',
})
export class TariffService {
  apiName = 'Default';
  

  cloneTariff = (tariffId: string, portId: string, typeOfCallId: string, customerId: string, vesselIds: string[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, TariffDto>({
      method: 'POST',
      url: '/api/app/tariff/clone-tariff',
      params: { tariffId, portId, typeOfCallId, customerId },
      body: vesselIds,
    },
    { apiName: this.apiName,...config });
  

  create = (input: CreateTariffDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, TariffDto>({
      method: 'POST',
      url: '/api/app/tariff',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/app/tariff/${id}`,
    },
    { apiName: this.apiName,...config });
  

  get = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, TariffDto>({
      method: 'GET',
      url: `/api/app/tariff/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getCount = (input: PageRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, number>({
      method: 'GET',
      url: '/api/app/tariff/count',
      params: { filter: input.filter, onlyActive: input.onlyActive, additionalData: input.additionalData, ignoreMaxResultCount: input.ignoreMaxResultCount, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getCustomerCtmTariffByPortIdAndCustomerId = (portId: string, customerId: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, TariffDto[]>({
      method: 'GET',
      url: '/api/app/tariff/customer-ctm-tariff',
      params: { portId, customerId },
    },
    { apiName: this.apiName,...config });
  

  getCustomerTariffByPortIdAndTypeOfCallIdAndVesselTypeIdAndCustomerId = (portId: string, typeOfCallId: string, vesselTypeId: string, customerId: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, TariffDto[]>({
      method: 'GET',
      url: '/api/app/tariff/customer-tariff',
      params: { portId, typeOfCallId, vesselTypeId, customerId },
    },
    { apiName: this.apiName,...config });
  

  getDropDownOptions = (input: DataRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<IdNameDto>>({
      method: 'GET',
      url: '/api/app/tariff/drop-down-options',
      params: { select: input.select, filter: input.filter, onlyActive: input.onlyActive, additionalData: input.additionalData, ignoreMaxResultCount: input.ignoreMaxResultCount, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getExpandById = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, TariffDto[]>({
      method: 'GET',
      url: `/api/app/tariff/${id}/expand`,
    },
    { apiName: this.apiName,...config });
  

  getExtraPropertiesById = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Record<string, object>>({
      method: 'GET',
      url: `/api/app/tariff/${id}/extra-properties`,
    },
    { apiName: this.apiName,...config });
  

  getFullListWithOutDetails = (input: PageRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, TariffListDto[]>({
      method: 'GET',
      url: '/api/app/tariff/full-list-with-out-details',
      params: { filter: input.filter, onlyActive: input.onlyActive, additionalData: input.additionalData, ignoreMaxResultCount: input.ignoreMaxResultCount, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getIds = (input: DataRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, string[]>({
      method: 'GET',
      url: '/api/app/tariff/ids',
      params: { select: input.select, filter: input.filter, onlyActive: input.onlyActive, additionalData: input.additionalData, ignoreMaxResultCount: input.ignoreMaxResultCount, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getList = (input: PageRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<TariffDto>>({
      method: 'GET',
      url: '/api/app/tariff',
      params: { filter: input.filter, onlyActive: input.onlyActive, additionalData: input.additionalData, ignoreMaxResultCount: input.ignoreMaxResultCount, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListWithOutDetails = (input: PageRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<TariffListDto>>({
      method: 'GET',
      url: '/api/app/tariff/with-out-details',
      params: { filter: input.filter, onlyActive: input.onlyActive, additionalData: input.additionalData, ignoreMaxResultCount: input.ignoreMaxResultCount, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getOneExtraPropertiesByIdAndKey = (id: string, key: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, object>({
      method: 'GET',
      url: `/api/app/tariff/${id}/one-extra-properties`,
      params: { key },
    },
    { apiName: this.apiName,...config });
  

  getPortTariffOnlyByPortIdAndTypeOfCallIdAndVesselTypeId = (portId: string, typeOfCallId: string, vesselTypeId: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, TariffDto[]>({
      method: 'GET',
      url: '/api/app/tariff/port-tariff-only',
      params: { portId, typeOfCallId, vesselTypeId },
    },
    { apiName: this.apiName,...config });
  

  getPriorityTariffByPortIdAndTypeOfCallIdAndVesselTypeIdAndCustomerId = (portId: string, typeOfCallId: string, vesselTypeId: string, customerId: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, TariffDto[]>({
      method: 'GET',
      url: '/api/app/tariff/priority-tariff',
      params: { portId, typeOfCallId, vesselTypeId, customerId },
    },
    { apiName: this.apiName,...config });
  

  getSchema = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, EntitySchemaDto>({
      method: 'GET',
      url: '/api/app/tariff/schema',
    },
    { apiName: this.apiName,...config });
  

  getTariffByPortAndTypeOfCallAndVesselTypeByPortIdAndTypeOfCallIdAndVesselTypeId = (portId: string, typeOfCallId: string, vesselTypeId: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, TariffDto[]>({
      method: 'GET',
      url: '/api/app/tariff/tariff-by-port-and-type-of-call-and-vessel-type',
      params: { portId, typeOfCallId, vesselTypeId },
    },
    { apiName: this.apiName,...config });
  

  getTariffByPortIdAndTypeOfCallIdAndVesselTypeId = (portId: string, typeOfCallId: string, vesselTypeId: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, TariffDto>({
      method: 'GET',
      url: '/api/app/tariff/tariff',
      params: { portId, typeOfCallId, vesselTypeId },
    },
    { apiName: this.apiName,...config });
  

  getTariffSubSections = (portId: string, typeOfCallId: string, customerId: string, chargeItemSectionId: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, TariffDto>({
      method: 'GET',
      url: '/api/app/tariff/tariff-sub-sections',
      params: { portId, typeOfCallId, customerId, chargeItemSectionId },
    },
    { apiName: this.apiName,...config });
  

  getTypeOfCall = (portId: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, string[]>({
      method: 'GET',
      url: `/api/app/tariff/type-of-call/${portId}`,
    },
    { apiName: this.apiName,...config });
  

  getWithDetails = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, TariffDto>({
      method: 'GET',
      url: `/api/app/tariff/${id}/with-details`,
    },
    { apiName: this.apiName,...config });
  

  resolveGroupCustomerRowId = (groupIdentifier: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, string>({
      method: 'POST',
      responseType: 'text',
      url: '/api/app/tariff/resolve-group-customer-row-id',
      params: { groupIdentifier },
    },
    { apiName: this.apiName,...config });
  

  setExtraPropertiesByIdAndKeyAndValue = (id: string, key: string, value: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: `/api/app/tariff/${id}/set-extra-properties`,
      params: { key, value },
    },
    { apiName: this.apiName,...config });
  

  update = (id: string, input: UpdateTariffDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, TariffDto>({
      method: 'PUT',
      url: `/api/app/tariff/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
  

  updateT = (id: string, input: UpdateTariffDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, TariffDto>({
      method: 'PUT',
      url: `/api/app/tariff/${id}/t`,
      body: input,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
